
import { ClassFlag } from "../../../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../../../library-js/dom-tools/ElementType";
import { ReminderButton } from "./reminder-button";
import { ReminderModeIcon } from "./reminder-mode-icon";
import { ReminderInput } from "./reminder-input";
import { ReminderModeElement } from "./ReminderModeElement";
import { ReminderUI } from "./reminder-ui";
import { MailEntry } from "../app/data/MailEntry";


export class ReminderMailView extends ReminderModeElement
{ 
  static type = new ElementType( "reminder-mail-view" );

  _buttons:ReminderButton[];
  get buttons(){ return this._buttons; }

  _getButton( flag:ClassFlag )
  {
    return this.buttons.find( b => flag.in( b.element ) );
  }

  get deleteButton(){ return this._getButton( ReminderButton.delete ); }
  get saveButton(){ return this._getButton( ReminderButton.save ); }
  get backButton(){ return this._getButton( ReminderButton.back ); }

  subject:ReminderInput;
  time:ReminderInput;
  message:ReminderInput;

  constructor( e:HTMLElement )
  {
    super( e );
    
    this._modeIcon = this.get( ReminderModeIcon );
    this._buttons = this.getAll( ReminderButton );

    this.subject = ReminderInput.getText( e, "Subject" );
    this.time = ReminderInput.getText( e, "Time" );
    this.message = ReminderInput.getText( e, "Message" );
    
  }

  _ui:ReminderUI;

  ensureDataIsSaved()
  {
    [ this.subject.text, this.time.text, this.message.text ].forEach( t => t.forceDispatch() );
  }

  setEntry( mailEntry:MailEntry )
  {
    this.subject.setTextSilently( mailEntry.subject );
    this.time.setTextSilently( mailEntry.date );
    this.message.setTextSilently( mailEntry.message );
  }

  initialize( ui:ReminderUI )
  {
    this._ui = ui;
    let app = ui.app;

    this.subject.text.addListener(
      ( e )=>
      {
        if ( ! app._editMailEntry )
        {
          return
        }

        app._editMailEntry.subject = e.newValue;

      }
    );

    this.time.text.addListener(
      ( e )=>
      {
        if ( ! app._editMailEntry )
        {
          return
        }

        app._editMailEntry.date = e.newValue;

      }
    );

    this.message.text.addListener(
      ( e )=>
      {
        if ( ! app._editMailEntry )
        {
          return
        }

        app._editMailEntry.message = e.newValue;

      }
    );
  }
}